import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import Banner from "../layout/Banner";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { confirmAccountVerification } from "../../slices/auth";
import SpaceFiller from "../layout/SpaceFiller";
import { ArrowLeftCircleIcon } from "@heroicons/react/24/solid";
import Card from "../layout/Card";
import { generateTranslatedText } from "../../utils/boilerplate";
import Button from "../layout/Button";
import Spinner from "../layout/Spinner";

export default function VerificationConfirm() {
  const { user, loading } = useAppSelector((state) => state.auth);
  const language = "EN";
  const { profileId } = useParams();

  // Get query parameters
  const [searchParams] = useSearchParams();
  const referralId = searchParams.get("referral_id");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(confirmAccountVerification({ profileId, referralId }));
  }, [dispatch, navigate, profileId, referralId, user?.profile.is_verified]);

  return (
    <div className="w-full h-screen overflow-scroll bg-off-white">
      <SpaceFiller>
        {loading || user === null ? (
          <div className="flex justify-center items-center">
            <Spinner size={8} />
          </div>
        ) : (
          <>
            {/* Card */}
            <Card
              colour="white"
              paddingX="px-8"
              paddingY="py-8"
              borderColour="none"
              className=" w-full max-w-md space-y-8"
            >
              {/* Header */}
              <div>
                <a href="/">
                  <img
                    className="mx-auto h-12 w-auto rounded-lg"
                    src="/img/logo/logo.svg"
                    alt="RaiseDiversity"
                  />
                </a>
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-black">
                  {generateTranslatedText(
                    "verification_confirm_title_success",
                    language
                  )}
                </h2>
                <p className="mt-5 text-secondary text-center text-sm">
                  {generateTranslatedText(
                    "verification_confirm_subtext_success",
                    language
                  )}
                </p>
              </div>

              <div className="text-center my-4">
                <Button
                  onClick={() => window.location.href = "/"}
                  bgColour="dark-blue"
                  borderColour="dark-blue"
                  textColour="white"
                >
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <ArrowLeftCircleIcon
                      className="h-5 w-5 text-white"
                      aria-hidden="true"
                    />
                  </span>
                  Return to site
                </Button>
              </div>
            </Card>
          </>
        )}
      </SpaceFiller>

      {/* Alert banner */}
      <Banner />
    </div>
  );
}
